module.exports = __webpack_public_path__ + "media/yolo-3.0/chevron-73847032.svg";